/* eslint-disable complexity */

import React from 'react';
import acquisitionTypes from '../../../../support/acquisitionTypes.ts';
import { useAcquisitionType } from '../../../../hooks/stateful/useAcquisitionType';
import CalculatePriceMessage from '../CalculatePriceMessage/CalculatePriceMessage';
import EditorialRightsMessage from '../EditorialRightsMessage/EditorialRightsMessage';
import BenefitsMessage from '../BenefitsMessage/BenefitsMessage';
import RoyaltyFreeCompanyMessage from '../RoyaltyFreeCompanyMessage/RoyaltyFreeCompanyMessage';
import { useAsset } from '../../../../hooks/stateful/useAsset';
import useSelectedIndex from '../../../../hooks/stateful/useSelectedIndex.ts';
import useOnLoad from '../../../../hooks/queries/useOnLoad';
import styles from '../Messages.module.scss';

const LicenseMessage = () => {
  const { selectedOption } = useSelectedIndex();
  const { acquisitionType } = useAcquisitionType();
  const { asset } = useAsset();
  const { response: { config: { hasPreferredPricing } = {} } = {} } =
    useOnLoad();
  if (
    [
      acquisitionTypes.SUBSCRIPTION_LICENSE,
      acquisitionTypes.ALACARTE_LICENSE,
    ].includes(acquisitionType) &&
    selectedOption?.type !== 'customlicense'
  ) {
    return null;
  }

  const editorialRightsVisible =
    asset.isImage() &&
    selectedOption?.type === 'standardlicense' &&
    asset.isEditorial();

  const renderLicenseMessage = () => {
    if (selectedOption?.type === 'customlicense') {
      return <CalculatePriceMessage />;
    }
    if (editorialRightsVisible) {
      return <EditorialRightsMessage />;
    }
    const shouldShowBenefitsMessage =
      asset.isRoyaltyFree() && !hasPreferredPricing;
    if (shouldShowBenefitsMessage) {
      return <BenefitsMessage />;
    }

    return null;
  };

  return (
    <section
      className={styles.messages}
      data-testid="license-message-container"
    >
      {renderLicenseMessage()}
      <div className={styles.parallel}>
        <RoyaltyFreeCompanyMessage />
      </div>
    </section>
  );
};

export default LicenseMessage;
